// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2QEyR","choiceBoxes":"toolbarselects_choiceBoxes__31bxc","simpleField":"toolbarselects_simpleField__1WPel"};